import { ProjectModel } from '../../../store/types';
import { ProjectStatus } from '../../../utils';

export enum ProjectCreationStatus {
    New = 'New',
    Saved = 'Saved',
    Proposed = 'Proposed',
    CompletedCreation = 'CompletedCreation',
}

export const getProjectCreationStatus = (
    project: ProjectModel
): ProjectCreationStatus => {
    if (!project?._id) {
        return ProjectCreationStatus.New;
    }

    if (project.currentStatus === ProjectStatus.saved) {
        return ProjectCreationStatus.Saved;
    }

    if (project.currentStatus === ProjectStatus.pending) {
        if (project.supervisor) {
            return ProjectCreationStatus.CompletedCreation;
        } else {
            return ProjectCreationStatus.Proposed;
        }
    }

    return ProjectCreationStatus.CompletedCreation;
};
